import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createObjectURLCache } from './objectURLCache';

// Dimensions are used to create a key.
// Cache is invalidated when different dimensions are provided.

export var getCacheKey = function getCacheKey(id, mode) {
  var resizeMode = mode || 'crop';
  return [id, resizeMode].join('-');
};
export var CardPreviewCacheImpl = /*#__PURE__*/_createClass(function CardPreviewCacheImpl(previewCache) {
  var _this = this;
  _classCallCheck(this, CardPreviewCacheImpl);
  _defineProperty(this, "get", function (id, mode) {
    var cacheKey = getCacheKey(id, mode);
    return _this.previewCache.get(cacheKey);
  });
  _defineProperty(this, "set", function (id, mode, cardPreview) {
    var cacheKey = getCacheKey(id, mode);
    _this.previewCache.set(cacheKey, cardPreview);
  });
  _defineProperty(this, "remove", function (id, mode) {
    var cacheKey = getCacheKey(id, mode);
    _this.previewCache.remove(cacheKey);
  });
  _defineProperty(this, "clear", function () {
    _this.previewCache.clear();
  });
  this.previewCache = previewCache;
});
export var mediaFilePreviewCache = new CardPreviewCacheImpl(createObjectURLCache());